export const addIds = (invoices) => {
  return invoices.map((invoice, i) => ({ ...invoice, number: i + 1 }));
};
